(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44562],{

/***/ 44562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _FooterBanner_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29631);
/* harmony import */ var _FooterBanner_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_FooterBanner_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ImageLoader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71700);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73040);






//TODO Açıklama Yazısını bağla.
var FooterBanner = function(param) {
    var currentRoutingTypeId = param.currentRoutingTypeId;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .m)(), footerBannerTitle = ref.footerBannerTitle, footerBannerCaption = ref.footerBannerCaption;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container -mb-40 relative  shadow-footerBanner h-auto lg:h-80  bg-no-repeat lg:bg-right-top bg-contain flex flex-col justify-center lg:pl-20 py-14 lg:py-0 " + (currentRoutingTypeId == "Reservation" ? "" : "sm:mt-32 ") + (_FooterBanner_module_css__WEBPACK_IMPORTED_MODULE_4___default().mobileBgPosition),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 bg-brand-blue-3 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/icons/FooterBanner.jpg",
                    loader: _ImageLoader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                    alt: "",
                    layout: "fill",
                    className: "object-top object-cover lg:object-contain lg:object-right-top"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                className: "font-bold relative leading-8 text-brand-black text-2xl lg:text-3xl w-80 max-w-full",
                dangerouslySetInnerHTML: {
                    __html: footerBannerTitle.replace("{", "<span class='text-white'>").replace("}", "</span>")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-15 text-brand-black opacity-50 mt-3 lg:w-5/12",
                children: footerBannerCaption
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FooterBanner);


/***/ }),

/***/ 71700:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Local = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return "".concat(src, "?quality=").concat(quality || 75);
};
/* harmony default export */ __webpack_exports__["Z"] = (Local);


/***/ }),

/***/ 29631:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobileBgPosition":"FooterBanner_mobileBgPosition__chsx3"};

/***/ })

}]);